'use client';

import { AsyncKeyCombobox } from './AsyncKeyCombobox';

interface EditableKeyCellProps {
  template: {
    key?: string;
    keyName?: string;
    id?: string;
  };
  onUpdate: (
    id: string,
    newKey: string | null,
    newKeyName: string | null
  ) => void;
  size?: 'sm' | 'md' | 'lg';
  onAddKey?: () => void;
}

export function EditableKeyCell({
  template,
  onUpdate,
  size = 'sm',
  onAddKey,
}: EditableKeyCellProps) {
  const sizeClass =
    size === 'sm' ? 'h-[32px]' : size === 'md' ? 'h-[40px]' : 'h-[48px]';
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <AsyncKeyCombobox
        value={
          template.key ? { value: template.key, label: template.keyName } : null
        }
        searchPlaceholder="Search key"
        setValue={(val) => {
          onUpdate(template.id, val?.value || null, val?.label || null);
        }}
        id={`key-${template.id}`}
        className={`${sizeClass} min-w-[180px]`}
        onAddKey={onAddKey}
      />
    </div>
  );
}
